import * as React from "react";
import { Box, Container, Stack, Text, Button, Input } from "@chakra-ui/react";
import Logo from "../../images/boo.png";
import Web3Service from "../../core/web3.service";
import { merge, tap } from "rxjs";
import { BigNumber, ethers } from "ethers";
import Web3 from "web3";

const TokenStakingView: React.FC = () => {
  const web3Service: Web3Service = Web3Service.shared();

  //State variables
  const [stakingAmount, SetStakingAmount] = React.useState<number>(0);
  const [stakedTokens, SetStakedTokens] = React.useState<string | undefined>(
    "",
  );
  const [myStakedTokens, SetMyStakedTokens] = React.useState<
    string | undefined
  >("");
  const [myTokens, SetMyTokens] = React.useState<string>("");
  const [tokens, setTokens] = React.useState<string>("");
  const [tokenReward, SetTokenReward] = React.useState<number | undefined>(0);
  const [rewardRate, SetRewardRate] = React.useState<number | undefined>(0);
  const [rewardDuration, SetRewardDuration] = React.useState<string>("");
  const [account, setAccount] = React.useState<string | undefined>(undefined);

  React.useEffect(() => {
    web3Service.getBooToken();
    web3Service.getBooTokenRate();
    web3Service.getBooReward();
    web3Service.getBooRewardDuration();
    web3Service.getStakedBooToken();

    const ownedTokens$ = web3Service.booTokens$.pipe(
      tap((val) => {
        SetMyTokens(Web3.utils.fromWei(BigNumber.from(val).toString()));
        setTokens(Web3.utils.fromWei(BigNumber.from(val).toString()));
      }),
    );
    const account$ = web3Service.account$.pipe(
      tap((account) => {
        setAccount(account);
      }),
    );

    const tokenRate$ = web3Service.booRewardRate$.pipe(
      tap((rate) => {
        SetRewardRate(rate);
      }),
    );

    const tokenReward$ = web3Service.booReward$.pipe(
      tap((reward) => {
        SetTokenReward(reward);
      }),
    );
    const rewardDuration$ = web3Service.booRewardDuration$.pipe(
      tap((duration) => {
        const days = Math.floor(duration! / (60 * 60 * 24));
        const hours = Math.floor((duration! % (60 * 60 * 24)) / (60 * 60));
        const minutes = Math.floor((duration! % (60 * 60)) / 60);

        SetRewardDuration(`${days} days, ${hours} hours, ${minutes} minutes`);
      }),
    );

    const stakedTokens$ = web3Service.stakedTokens$.pipe(
      tap((tokens) => {
        SetStakedTokens(Web3.utils.fromWei(tokens.toString()));
        SetMyStakedTokens(Web3.utils.fromWei(tokens.toString()));
      }),
    );

    const subscribe = merge(
      account$,
      ownedTokens$,
      tokenRate$,
      rewardDuration$,
      tokenReward$,
      stakedTokens$,
    ).subscribe();

    return () => subscribe.unsubscribe();
  }, [account]);

  //State Functions
  const OnStakedAmountChanged = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.value === "0" || e.target.value === "") {
      SetStakingAmount(0);
    } else {
      SetStakingAmount(Number.parseFloat(e.target.value));
    }
  };

  //Logic
  const Withdraw = async () => {
    const tokenToWithdraw = ethers.utils.parseUnits(stakedTokens!);
    console.log(tokenToWithdraw);

    await web3Service.withdrawBooToken(tokenToWithdraw);
  };

  const Stake = async () => {
    const tokenToStake = ethers.utils.parseUnits(tokens);
    await web3Service.stakeBooToken(tokenToStake);
    SetStakingAmount(0);
  };

  const Max = () => SetStakingAmount(Number(tokens));

  const ClaimReward = () => web3Service.claimBooReward();

  //UI
  return (
    <Stack gap={"20px"}>
      <Container p={"25px"} backdropFilter={"blur(10px)"} borderRadius={"20px"}>
        <Stack alignItems={"center"} flexDirection={"row"}>
          <img src={Logo} height={"50px"} width={"140px"} alt={"Logo"} />
          <Box>
            <Text fontSize={"2em"} fontWeight={"bold"}>
              $BOO
            </Text>
            <Text color={"grey"}>Staking Token</Text>
          </Box>
        </Stack>
        <Box
          display={"flex"}
          height={"50px"}
          flexDirection="row"
          alignItems={"center"}
          justifyContent={"center"}
          gap={"50px"}
          mt={"50px"}
        >
          <Text fontWeight={"bold"}>
            Staked Tokens:
            <br />
            {Number(myStakedTokens).toFixed(3)}
          </Text>

          <Text fontWeight={"bold"}>
            Reward Rate: <br />
            {rewardRate}
          </Text>
          <Text fontWeight={"bold"}>
            My Tokens:
            <br />
            {Number(myTokens).toFixed(3)}
          </Text>
        </Box>
      </Container>
      <Container p={"50px"} backdropFilter={"blur(10px)"} borderRadius={"20px"}>
        <Stack flexDirection={"row"} alignItems={"center"} gap={"20px"}>
          <img src={Logo} alt={"Logo"} width={"140px"} height={"50px"} />
          <Input
            placeholder="0"
            inputMode="numeric"
            value={stakingAmount}
            name={stakingAmount?.toString()}
            onChange={OnStakedAmountChanged}
          />
          <Button onClick={Max} pl={"40px"} pr={"40px"}>
            Max
          </Button>
        </Stack>
        <Stack pt={"20px"}>
          <Button onClick={Stake}>Stake</Button>
          <Button onClick={ClaimReward}>Claim rewards</Button>
          <Button onClick={Withdraw}>Withdraw all</Button>
        </Stack>
      </Container>
      <Stack
        pt={"50px"}
        backdropFilter={"blur(10px)"}
        borderRadius={"20px"}
        alignItems={"center"}
        justifyContent={"center"}
      >
        <Stack p={"20px"} gap={"10px"}>
          <Text fontWeight={"bold"}>Rewards:</Text>
          <Text>{tokenReward}</Text>
          <Text fontWeight={"bold"}>Finish period:</Text>
          <Text>{rewardDuration}</Text>
        </Stack>
      </Stack>
    </Stack>
  );
};

export default TokenStakingView;
